import { useNavigate } from "react-router-dom";
import { intl } from "LocaleWrapper";
import { useQuery, useMutation } from "@apollo/client";

import { Table, PageHeader, Card, Button } from "@cofano/cck";
import DeleteIcon from "@mui/icons-material/Delete";

import { TableId, useFrontendTable } from "components/table";
import { useConfirm } from "components/hooks/useConfirm";
import Helmet from "components/helmet/Helmet";

import { Language, usePermission } from "imports/Utils";

import { GetSailingSchedulesDocument } from "__generated__/view/sailingschedules/graphql/queries.generated";
import { DeleteSailingScheduleDocument } from "__generated__/view/sailingschedules/graphql/mutations.generated";

const SailingSchedules = () => {

	const confirm = useConfirm();
	const navigate = useNavigate();
	const { isAdmin, isMasterdata, isCompanyUser, isReadOnly } = usePermission();

	const  { data, refetch, loading }  = useQuery(GetSailingSchedulesDocument);
	const [ deleteSailingSchedule ] = useMutation(DeleteSailingScheduleDocument);

	const { tableProps, refetchAfterDelete } = useFrontendTable({
		id: TableId.SailingSchedules,
		content: (data?.sailingSchedules || []),
		paginationEnabled: false,
	});

	return (
		<div>
			<PageHeader>
				<PageHeader.Title>
					{Language("SAILING_SCHEDULES")}
					<Helmet title={intl.formatMessage({ id: "SAILING_SCHEDULES" })} />
				</PageHeader.Title>

				<PageHeader.Actions>
					{!isReadOnly && (
						<Button onClick={() => navigate("/view/sailingschedules/create")}>
							{Language("ADD_BUTTON")}
						</Button>
					)}
				</PageHeader.Actions>
			</PageHeader>

			<Card disablePadding>
				<Table
					{...tableProps}
					disableFooter={true}
					contentLoading={loading}
					columns={[ {
						id: "schedule",
						title: intl.formatMessage({ id: "SAILING_SCHEDULE" }),
						sortable: true,
						filterComponent: "TEXT",
					} ]}
					rowActions={(isAdmin || isMasterdata || isCompanyUser) && !isReadOnly ? [ {
						icon: <DeleteIcon />,
						onClick: (row) => {
							confirm({
								type: "DELETE",
							}).then(() => {
								deleteSailingSchedule({
									variables: {
										id: row.id,
									},
									onCompleted: () => {
										refetchAfterDelete();
										refetch();
									},
								});
							});
						},
					} ] : undefined} />
			</Card>
		</div>
	);
};

export default SailingSchedules;
